// extracted by mini-css-extract-plugin
export default {"font_14":"style_font_14__S4V78"};